import React from 'react';
import { Wrapper } from './BasicConfigTable.Styles';
import { DataGrid } from '@mui/x-data-grid';
var columns = [
    {
        field: 'name',
        headerName: 'Name',
        flex: 1
    },
    {
        field: 'value',
        headerName: 'Value',
        flex: 1
    },
];
export var BasicConfigTable = function (_a) {
    var data = _a.data;
    var rows = [
        // { id: '1', name: 'Clear Pacing', value: data?.clearPacing || '-' },
        {
            id: '1',
            name: 'Live Party Handler',
            value: (data === null || data === void 0 ? void 0 : data.livePartyHandler) || '-'
        },
        {
            id: '2',
            name: 'Live Party Contact Flow',
            value: (data === null || data === void 0 ? void 0 : data.livePartyContactFlow) || '-'
        },
        {
            id: '3',
            name: 'Answering Machine Handler',
            value: (data === null || data === void 0 ? void 0 : data.answeringMachineHandler) || '-'
        },
        {
            id: '4',
            name: 'Answering Machine Studio Flow',
            value: (data === null || data === void 0 ? void 0 : data.answeringMachineContactFlow) || '-'
        },
        { id: '5', name: 'Phones', value: (data === null || data === void 0 ? void 0 : data.phones.toString()) || '-' },
    ];
    return (React.createElement(Wrapper, null,
        React.createElement(DataGrid, { rows: rows, columns: columns, pageSize: 10, rowsPerPageOptions: [10], hideFooter: true, autoHeight: true, density: 'compact' })));
};
BasicConfigTable.defaultProps = {
// bla: 'test',
};
//# sourceMappingURL=BasicConfigTable.js.map